module.exports = __webpack_public_path__ + "static/media/tarot-card-5.2014566a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/tarotcards/tarot-card-5.jpg
// module id = 145
// module chunks = 0